/**
 * Return the only payment method that can be used in this store.
 *
 * The checkout deliberately does not guess when several methods are available: choosing cash,
 * terminal or QR changes the destination wallet. Selection is UI state only; this helper never
 * writes a setting and is safe for organizations created before ADS-FIX-2026-002.
 */
export const soleActivePaymentMethod = (paymentMethods, storeId) => {
  if (!storeId || !Array.isArray(paymentMethods)) return null
  const active = paymentMethods.filter(method => method?.activeInStore?.[storeId])
  return active.length === 1 ? active[0] : null
}

/** Reconcile checkout state with the live directory and choose an unambiguous default. */
export const reconcilePaymentMethod = (paymentMethods, storeId, current) => {
  if (!storeId || !Array.isArray(paymentMethods)) return null
  const active = paymentMethods.filter(method => method?.activeInStore?.[storeId])
  const liveCurrent = active.find(method => method.id === current?.id)
  if (liveCurrent) return liveCurrent
  if (active.length === 1) return active[0]
  const cashMethods = active.filter(method => method.isCash === true)
  return cashMethods.length === 1 ? cashMethods[0] : null
}

export const localizedDefaultCashName = (locale, translate) => {
  const language = typeof locale === 'string' ? locale.trim().toLowerCase().split(/[-_]/)[0] : ''
  if (language === 'kk') return 'Қолма-қол'
  if (language === 'ru') return 'Наличные'
  return translate('cash')
}
